import type { PaginatedResponse } from "@/types";
import type { InvoicedPayment } from "@/types/payment";
import { apiUrl } from "@/utils/url";
import { HttpClient } from "../HttpClient";
import { isAbortError, toServiceError } from "../errors";
import type {
  ClientInvoicedPaymentsParams,
  IPaymentsService,
} from "./IPaymentsService";

export class PaymentsService implements IPaymentsService {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient({
      baseURL: apiUrl,
    });
  }

  async getClientInvoicedPayments(
    clientId: number,
    {
      startDate,
      endDate,
      statusCode,
      invoiceNumber,
      page,
      size,
      signal,
    }: ClientInvoicedPaymentsParams = {},
  ): Promise<PaginatedResponse<InvoicedPayment>> {
    const params = new URLSearchParams();
    if (page !== undefined) params.append("page", String(page));
    if (size !== undefined) params.append("size", String(size));
    const query = params.toString();
    const trimmedInvoiceNumber = invoiceNumber?.trim();
    // No sort: the backend lists them newest first.
    const searchParameters = {
      ...(startDate ? { startDate } : {}),
      ...(endDate ? { endDate } : {}),
      ...(statusCode ? { statusCode } : {}),
      ...(trimmedInvoiceNumber ? { invoiceNumber: trimmedInvoiceNumber } : {}),
    };
    try {
      return await this.httpClient.post<PaginatedResponse<InvoicedPayment>>(
        `/payments/client/${clientId}/invoiced${query ? `?${query}` : ""}`,
        searchParameters,
        { signal },
      );
    } catch (error) {
      if (isAbortError(error)) throw error;
      throw toServiceError(
        error,
        "Não foi possível carregar os pagamentos do cliente. Atualize a página e tente novamente.",
      );
    }
  }
}
